var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8043 1.37931C13.9864 0.344828 13.0049 0 11.8598 0C10.7147 0 9.56962 0.344828 8.7517 1.37931L8.09737 2.06897L7.27945 1.37931C6.46154 0.344828 5.31646 0 4.17137 0C3.18987 0 2.04479 0.344828 1.22687 1.37931C-0.408958 3.10345 -0.408958 6.03448 1.22687 7.93103L1.88121 8.62069L8.09737 15L14.15 8.62069L14.8043 7.93103C16.6037 6.03448 16.6037 3.10345 14.8043 1.37931Z",
    fill: "#e32323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullS);
export default __webpack_public_path__ + "static/media/full_s.24f96c674b3211774e6b5582cd61b379.svg";
export { ForwardRef as ReactComponent };